export const api = "https://restcountries.com/v3.1";
export const api2 =
  "https://restcountries.com/v2";
